<script setup lang="ts">
import { Side } from "../core/round";
import { _battle } from "../ui/battle";
import { computed } from "vue";

const battle = _battle;
const props = withDefaults(
    defineProps<{ side: Side; forceDisabled?: boolean }>(),
    { forceDisabled: false }
);

const needReplacement = computed(() => battle.needsReplacement(props.side));
const replacementReady = computed(() => !!battle.getReplacement(props.side));

const disabled = computed(
    () =>
        battle.phase !== "selecting" ||
        battle.viewMode !== "live" ||
        props.forceDisabled ||
        (needReplacement.value && !replacementReady.value)
);

const selected = computed(
    () =>
        battle.hasSelected(props.side) &&
        battle.getPending(props.side)?.kind === "skip"
);
</script>

<template>
    <button
        class="skip-btn"
        :class="{ selected }"
        :disabled="disabled"
        @click="battle.selectOperation(side, { kind: 'skip' })"
        title="空过"
    >
        <img class="skip-icon" src="/assets/ban.svg" alt="" />
        <span>空过</span>
    </button>
</template>

<style scoped>
.skip-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: calc(var(--ui-unit) * 5);
    width: calc(var(--ui-unit) * 72);
    height: calc(var(--ui-unit) * 58);
    padding: calc(var(--ui-unit) * 5);
    background: rgba(30, 30, 45, 0.9);
    border: calc(var(--ui-unit) * 1) solid rgba(255, 255, 255, 0.08);
    color: #e0e0e0;
    border-radius: calc(var(--ui-unit) * 8);
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.skip-btn:hover:not(:disabled) {
    background: rgba(40, 40, 60, 0.95);
    border-color: rgba(239, 68, 68, 0.4);
    box-shadow: 0 0 calc(var(--ui-unit) * 10) rgba(239, 68, 68, 0.15);
}

.skip-btn.selected {
    border-color: #ef4444;
    background: rgba(239, 68, 68, 0.1);
    box-shadow: 0 0 calc(var(--ui-unit) * 12) rgba(239, 68, 68, 0.2);
}

.skip-btn:disabled {
    cursor: not-allowed;
    opacity: 0.3;
}

.skip-icon {
    width: calc(var(--ui-unit) * 24);
    height: calc(var(--ui-unit) * 24);
    filter: brightness(0) invert(1);
    pointer-events: none;
}

.skip-btn span {
    font-size: calc(var(--ui-unit) * 12);
    font-weight: 600;
}
</style>
